<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>
              {{ `${this.$t("complaints.view.title")}` }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("complaints.view.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10 text--primary">
            <v-form>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.added_by")}` }} :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  {{ complaint.added_by }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.house_no")}` }} :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  <span v-if="complaint.flat_name"
                    >{{ complaint.flat_name }}-</span
                  >
                  <span>{{ complaint.house_number }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.title")}` }} :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  {{ complaint.title }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.status")}` }} :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  {{
                    complaint.status === 0
                      ? "Pending"
                      : complaint.status === 1
                      ? "In Progress"
                      : complaint.status === 2
                      ? "Closed"
                      : complaint.status === 3
                      ? "Cancelled"
                      : ""
                  }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.priority")}` }}
                    :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  {{
                    complaint.priority === 1
                      ? "Low"
                      : complaint.priority === 2
                      ? "Medium"
                      : complaint.priority === 3
                      ? "High"
                      : complaint.priority === 0
                      ? "Emergency"
                      : ""
                  }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.date")}` }} :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  {{ getFormattedDate(complaint.created_on) }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("complaints.view.headers.description")}` }}
                    :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="6" md="9">
                  {{ complaint.description }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" xs="4" sm="4" md="3">
                  <span class="h2 font-weight-bold"
                    >{{ `${this.$t("notice.view.headers.document")}` }} :
                  </span>
                </v-col>
                <v-col cols="8" xs="8" sm="8" md="9">
                  <v-row>
                    <v-col
                      v-for="item in added_documents"
                      :key="item.document_url"
                      class="d-flex child-flex"
                      cols="3"
                    >
                      <v-card>
                        <v-img
                          v-if="item.file_type == 'image'"
                          :src="API_BASE_URL + '/uploads/' + item.document_url"
                          :lazy-src="
                            API_BASE_URL + '/uploads/' + item.document_url
                          "
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                          v-else
                          :src="API_BASE_URL + '/default-pdf.png'"
                          :lazy-src="API_BASE_URL + '/default-pdf.png'"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-btn
                          icon
                          color="secondary"
                          name="view_notice"
                          title="Edit "
                          @click="imgClick(item)"
                          style="float: right"
                        >
                          <v-icon small v-if="item.file_type == 'image'">
                            mdi-eye</v-icon
                          >
                          <v-icon small v-else> mdi-eye</v-icon>
                        </v-btn>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},

      complaint: {
        title: "",
        description: "",
        picture_url: "",
      },
      added_documents: [],
      base_url: process.env.VUE_APP_API_URL,
      imageDialog: false,
      image_url: "",
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getComplaintsDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/complaints/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.complaint = data.complaint;
            this.complaint.documents.map((x) => {
              x.name = x.document_url.replace("complaint_documents/", "");
            });

            _self.added_documents = data.complaint.documents;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    imgClick(item) {
      // if (item.file_type == "image") {
      //   this.image_url = item.document_url;
      //   this.imageDialog = true;
      // } else {
      window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
      // }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getComplaintsDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>
